import { createZodDto } from 'nestjs-zod/dto';
import { AcceptIndividualInvitationSchema } from './accept-individual-invitation.dto';
export const AcceptSsoInvitationForExistingMemberSchema = AcceptIndividualInvitationSchema;
export class AcceptSsoInvitationForExistingMemberDto extends createZodDto(AcceptSsoInvitationForExistingMemberSchema) {
}
